import styled from '@emotion/styled';
import React from 'react';
import dotOrnament from '../../assets/images/dot-ornament.svg';

const TitleHeader3WithDots = ({ title, color }) => {
  return (
    <HeaderWrapper>
      <StyledHeader3 titleColor={color}>{title}</StyledHeader3>
      <img id="dot" src={dotOrnament} alt="dot ornament" />
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  position: relative;
  margin-bottom: 25px;

  #dot {
    width: 65px;
    position: absolute;
    left: -10px;
    top: -50px;
    z-index: 0;
  }
`;

const StyledHeader3 = styled.h3`
  width: auto;
  color: ${(props) => props.titleColor};
  font-family: Anton;
  font-size: 25px;
  letter-spacing: 1px;
  line-height: 33px;
  z-index: 2;

  &::before {
    position: absolute;
    width: 50px;
    content: ' ';
    border: 4px solid #00c2ba;
    background-color: #00c2ba;
    border-radius: 4px;
    top: -20px;
    z-index: inherit;
  }

  @media only screen and (max-width: 1024px) {
    #dot {
      display: none;
    }
`;

export default TitleHeader3WithDots;
